// extracted by mini-css-extract-plugin
module.exports = {"noteField":"styles_noteField__1Ndkt","buttons":"styles_buttons__2I89y"};